import { DefaultApi } from './api';
import {
  ApiResponse,
  SendSMSAccessChecklist,
  SendTokenAccessChecklist,
  ResponseOnboardingToken,
} from './types';

export const sms = (data: SendSMSAccessChecklist) =>
  DefaultApi.request(`/recovery-code`, {
    method: 'POST',
    data,
  });

export const getToken = (data: SendTokenAccessChecklist) =>
  DefaultApi.post<ApiResponse<ResponseOnboardingToken>>('/login', data);
